import { styled } from '@attentive-platform/stem-ui';

export const FormContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'center'
}));

export const InputContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  alignItems: 'center',
  width: '100%'
}));

export const FlexItem = styled('div')(() => ({
  flex: 1
}));

export const ErrorText = styled('div')(() => ({
  color: 'var(--color-error-50)',
  fontWeight: 'bold'
}));

export const StyledBreakWordContainer = styled('div')(() => ({
  wordBreak: 'break-word' /* Standard */,
  overflowWrap: 'break-word',
  width: '100%'
}));

export const InfoText = styled('div')(() => ({
  padding: '10px 14px',
  borderRadius: '4px',
  margin: '10px 0',
  borderLeft: '3px solid #4a5568',
  backgroundColor: '#f7fafc'
}));

export const WideCard = styled('div')({
  width: 'min(1040px, calc(100vw - 64px))'
});

export const ModalTitle = styled('span')({
  fontSize: 20,
  fontWeight: 650,
  lineHeight: '28px',
  color: '#111827'
});

export const ModalBody = styled('div')({
  display: 'flex',
  width: 520,
  flexDirection: 'column',
  textAlign: 'left',
  gap: 20
});

export const ModalSubtitle = styled('p')({
  margin: '-12px 0 0',
  fontSize: 14,
  lineHeight: '20px',
  color: '#6b7280'
});

export const ModalActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 8
});
